export const PAGE_TITLE = 'Enter prescription label information';
export const PAGE_TYPE = 'registration-blocked';
import { safeJsonParse } from '../utils/utils';

// Registration blocked error messages
export const REGISTRATION_BLOCKED_ERRORS = {
  NO_MATCH_FOUND_TITLE: 'We couldn\'t find you',
  NO_MATCH_FOUND_DESCRIPTION: 'Check your info to make sure it\'s right. If you need help, call us at',
  CLIENT_BLOCKED_TITLE: 'You need to register another way',
  CLIENT_BLOCKED_DESC:
    'Call us at the number on your Member ID card to complete your registration. We\'re available Monday through Friday from 7 PM to 9 PM (CT), and Saturday from 8 AM to 12 PM (CT).',
  LOCKED_TITLE: 'Your account has been locked',
  LOCKED_DESCRIPTION:
    'To protect your privacy, your account has been locked by a member of our Customer Care team. Please contact Customer Care for assistance.',
  EXPIRED_TITLE: 'Your plan has expired',
  EXPIRED_DESCRIPTION:
    'You need current or recent coverage to register. If you think there\'s been a mistake, call the number on your Member ID card.',
  UNDER_AGE_TITLE: 'You don\'t meet the minimum age requirement',
  UNDER_AGE_DESCRIPTION:
    'Your health plan requires a minimum age to register. If you have questions, please call the number on your Member ID card.',
  FUTURE_ELIGIBILITY_TITLE: 'It\'s too early to register',
  FUTURE_ELIGIBILITY_DESCRIPTION:
    'You can register once your benefits period begins. If you have any questions, please call the number on your Member ID card.',
  ELIGIBLE_PLAN_NOT_FOUND_TITLE: 'We can\'t register you',
  ELIGIBLE_PLAN_NOT_FOUND_DESCRIPTION: 'We couldn\'t find any eligible plan to register',
  ACCOUNT_LOCKED: 'Your registration is locked for 30 minutes',
  ACCOUNT_LOCKED_DESCRIPTION: 'There were too many tries to verify your mobile number. If you need help, call us at'
};

// Translation configuration for registration-blocked page
export const REGISTRATION_BLOCKED_TRANSLATION_CONFIG = [
  { key: PAGE_TITLE, value: PAGE_TITLE, message: PAGE_TITLE },
  {
    key: 'REGISTRATION_BLOCKED_ERRORS',
    value: REGISTRATION_BLOCKED_ERRORS,
    message: JSON.stringify(REGISTRATION_BLOCKED_ERRORS)
  }
];

// Helper function to process translated items
export const processRegistrationBlockedTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  // Destructure simple string values with fallbacks
  const { [PAGE_TITLE]: PAGE_TITLE_TRANSLATED = PAGE_TITLE } = translatedItems;

  return {
    PAGE_TITLE: PAGE_TITLE_TRANSLATED,
    PAGE_TYPE: PAGE_TYPE,
    // Keep safeJsonParse for complex objects that need JSON parsing
    REGISTRATION_BLOCKED_ERRORS: safeJsonParse(
      translatedItems[JSON.stringify(REGISTRATION_BLOCKED_ERRORS)],
      REGISTRATION_BLOCKED_ERRORS
    )
  };
};
